import type { Maybe, Undef } from 'types/UtilityTypes';
import { QuotingPortals } from 'types/enums/Integrations';

import { normalizeEmergeMarketQuoteLoadId } from './emergeMarket/normalizeLoadId';
import { normalizeInsightTMSLoadId } from './insightTms/normalizeLoadId';
import { normalizeKewillSID } from './kewill/normalizeLoadId';
import { normalizeManhattanShipmentId } from './manhattan/normalizeShipmentId';
import { normalizeMercuryGateLoadId } from './mercuryGate/normalizeLoadId';
import { normalizePortalLoadIdToNumericCore } from './normalizePortalLoadId';
import { normalizeTruckerToolsLoadId } from './truckerTools/normalizeLoadId';
import { normalizeUberFreightLoadId } from './uberFreight/normalizeLoadId';

export type SubmitBidLoadIdNormalizer = (raw: string) => string;

export function shouldPreserveInvalidSubmitBidLoadId(
  portalName: Maybe<Undef<string>>
): boolean {
  return (
    portalName !== QuotingPortals.InsightTMS &&
    portalName !== QuotingPortals.Kewill &&
    portalName !== QuotingPortals.Manhattan &&
    portalName !== QuotingPortals.MercuryGate &&
    portalName !== QuotingPortals.TruckerTools &&
    portalName !== QuotingPortals.EmergeMarket
  );
}

// Portal-specific load-id normalizer for submit-bid.
// Default / unknown portals use the numeric-core normalizer.
// Insight TMS keeps its suffix; Manhattan keeps its shipment prefix.
export function getSubmitBidLoadIdNormalizer(
  portalName: Maybe<Undef<string>>
): SubmitBidLoadIdNormalizer {
  if (portalName === QuotingPortals.InsightTMS) {
    return normalizeInsightTMSLoadId;
  }

  if (portalName === QuotingPortals.Kewill) {
    return normalizeKewillSID;
  }

  if (portalName === QuotingPortals.Manhattan) {
    return normalizeManhattanShipmentId;
  }

  if (portalName === QuotingPortals.TruckerTools) {
    return normalizeTruckerToolsLoadId;
  }

  if (portalName === QuotingPortals.MercuryGate) {
    return normalizeMercuryGateLoadId;
  }

  if (portalName === QuotingPortals.EmergeMarket) {
    return normalizeEmergeMarketQuoteLoadId;
  }

  if (portalName === QuotingPortals.UberFreight) {
    return normalizeUberFreightLoadId;
  }

  return normalizePortalLoadIdToNumericCore;
}
